<template>
    <div class="text-center pt-4">
        <a class="text-white no-underline m-2 inline-block" :href="facebookUrl" target="_blank" rel="noopener" aria-label="Facebook">
            <div class="rounded text-sm font-bold py-2 px-3 resp-sharing-button--facebook">
                <i class="text-xs sm:text-xs icon-facebook mr-1"></i>
                Share</div>
        </a>
        <a class="text-white no-underline m-2 inline-block" :href="twitterUrl" target="_blank" rel="noopener" aria-label="X">
            <div class="rounded text-sm font-bold py-2 px-3 resp-sharing-button--twitter">
                <i class="text-xs sm:text-xs icon-x mr-1"></i>
                Post</div>
        </a>
        <a class="text-white no-underline m-2 inline-block" :href="emailUrl" target="_self" rel="noopener" aria-label="E-Mail">
            <div class="rounded text-sm font-bold py-2 px-3 resp-sharing-button--email">
                <i class="text-xs sm:text-xs icon-envelope-o mr-1"></i>
                Email</div>
        </a>
        <a class="text-white no-underline m-2 inline-block" :href="whatsappUrl" target="_blank" rel="noopener" aria-label="WhatsApp">
            <div class="rounded text-sm font-bold py-2 px-3 resp-sharing-button--whatsapp">
                <i class="text-xs sm:text-xs icon-whatsapp mr-1"></i>
                WhatsApp</div>
        </a>
    </div>
</template>

<script>
export default {
    name: "SocialShareComponent.vue",
    props: ['pid','title','ourDomain'],
    data() {
        return {
            propertyId: this.pid,
        }
    },
    computed: {
        propertyUrl() {
            return `${this.ourDomain}p/${this.propertyId}/`;
        },
        facebookUrl() {
            return `https://facebook.com/sharer/sharer.php?u=${this.propertyUrl}`
        },
        twitterUrl() {
            return `https://twitter.com/intent/tweet/?text=${encodeURIComponent(this.title)}&url=${encodeURIComponent(this.propertyUrl)}`
        },
        emailUrl() {
            return `mailto:?subject=${encodeURIComponent(this.title)}&body=${this.propertyUrl}`
        },
        whatsappUrl() {
            return `whatsapp://send?text=${encodeURIComponent(this.title)}%20${this.propertyUrl}`
        }
    }
}
</script>

<style scoped>
.resp-sharing-button--twitter {
    background-color: #000000
}

.resp-sharing-button--twitter:hover {
    background-color: #464242
}

.resp-sharing-button--facebook {
    background-color: #3b5998
}

.resp-sharing-button--facebook:hover {
    background-color: #2d4373
}

.resp-sharing-button--email {
    background-color: #777
}

.resp-sharing-button--email:hover {
    background-color: #5e5e5e
}

.resp-sharing-button--whatsapp {
    background-color: #149b46
}

.resp-sharing-button--whatsapp:hover {
    background-color: #117332
}

.resp-sharing-button--facebook {
    background-color: #3b5998;
    border-color: #3b5998;
}

.resp-sharing-button--facebook:hover,
.resp-sharing-button--facebook:active {
    background-color: #2d4373;
    border-color: #2d4373;
}

.resp-sharing-button--twitter {
    background-color: #000000;
    border-color: #000000;
}

.resp-sharing-button--twitter:hover,
.resp-sharing-button--twitter:active {
    background-color: #464242;
    border-color: #464242;
}

.resp-sharing-button--email {
    background-color: #777777;
    border-color: #777777;
}

.resp-sharing-button--email:hover,
.resp-sharing-button--email:active {
    background-color: #5e5e5e;
    border-color: #5e5e5e;
}

.resp-sharing-button--whatsapp {
    background-color: #149b46;
    border-color: #149b46;
}

.resp-sharing-button--whatsapp:hover,
.resp-sharing-button--whatsapp:active {
    background-color: #117332;
    border-color: #117332;
}
</style>
